import React from 'react'

function TechSelectRecAir() {
  return (
    <embed src="\pdfs\D2.5.2.2_LG-UM-M-LB_Dezentrales_Lueftungsgeraet_fuer_Mischlueftung-liegend_03.2014-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectRecAir